import React from "react";
import {useTranslation} from "react-i18next";
// local
import AgreementCardSwitch from "./components/AgreementCardSwitch";
import {getFullName} from "helpers/helper";
import {dateFormat} from "helpers/datetime";
import Upload from "components/Upload";
import {ourAgreementsTypes} from "constants/user.consts";
import {fileExtension} from "constants/file.consts";

const fileExtensions = [
  fileExtension.PDF,
  fileExtension.PNG,
  fileExtension.JPG,
  fileExtension.XLS,
];

const AgreementCardUE2021 = ({
  agreement,
  isAdminOwner,
  ourOrganizationName,
  organizationName,
  onUpdate,
  onLoadFile,
  onRemoveFile,
}) => {
  const {t} = useTranslation();

  const user = agreement?.UpdatedUser;
  const userName = getFullName(user?.firstName, user?.lastName);
  const baseLabel = `${agreement?.type} ${t("WITH")} ${organizationName}`;
  const activeLabel = `${ourOrganizationName} ${t(
    "OUR_AGREEMENTS_SWITCH_LABEL_2"
  )} ${baseLabel}`;
  const inactiveLabel = `${t("OUR_AGREEMENTS_SWITCH_LABEL_1")} ${ourOrganizationName} ${t(
    "OUR_AGREEMENTS_SWITCH_LABEL_2"
  )} ${baseLabel}`;
  const inactiveMemberLabel = `${ourOrganizationName} ${t(
    "OUR_AGREEMENTS_SWITCH_LABEL_3"
  )} ${baseLabel}`;
  const hasFiles = !!agreement?.Files?.length;

  return (
    <div className="agreement-card mb-8">
      <h3 className="agreement-card__title">{agreement?.title}</h3>
      <div className="agreement-card__body">
        <div className="agreement-card__body__row mb-2">
          <AgreementCardSwitch
            isAdminOwner={isAdminOwner}
            checked={agreement?.checked}
            onClick={(checked) => onUpdate({type: agreement?.type, checked})}
            activeLabel={activeLabel}
            inactiveLabel={inactiveLabel}
            inactiveMemberLabel={inactiveMemberLabel}
          />
        </div>
        {agreement?.checked && isAdminOwner && (
          <Upload
            variant="agreement"
            uploadRequest={(file) =>
              onLoadFile(file, ourAgreementsTypes.UE2021, agreement?.id)
            }
            removeRequest={(id) =>
              onRemoveFile(ourAgreementsTypes.UE2021, agreement?.id, id)
            }
            customFileTypes={fileExtensions}
            wrapperClass="mb-0 pt-2 mr-0 ml-2"
            files={agreement?.Files}
          />
        )}
        {agreement?.updatedAt && agreement?.UpdatedUser && isAdminOwner && (
          <div
            className={`agreement-card__body__updated-description${
              hasFiles ? " mt-2" : ""
            }`}
          >
            {`${t("OUR_AGREEMENTS_UPDATED_DESCRIPTION")} ${userName} ${t(
              "ON-DATE"
            )} ${dateFormat(agreement?.updatedAt)}`}
          </div>
        )}
      </div>
    </div>
  );
};

export default AgreementCardUE2021;
